import React, { useContext, useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';
import { SignInModal, CreateAccountModal, ResetPasswordModal } from 'sub-components';
import './PageHeader.scss'
import AuthContext from 'app/AuthContext';
import Module from 'sub-components/module/Module';
import profileImage from 'images/blank-profile-picture.png'
import projectIcon from 'images/project-icon.png';
import profileIcon from 'images/profile-icon.png';
import multiProjectsIcon from 'images/multi-projects-icon.png';
import { getEnvConfig, formatAvatarUrl } from 'lib/utils';

const PageHeader = (props) => {
    const { authToken, userMetadata} = useContext(AuthContext);
    const [header, setHeader] = useState(props.header);
    const [subHeader, setSubHeader] = useState(props.subHeader);
    const [preHeader, setPreHeader] = useState(props.preHeader);
    const [displayLearnMoreBtn, setDisplayLearnMoreBtn] = useState(props.displayLearnMoreBtn || 'none');
    const [displayGoHomeBtn, setDisplayGoHomeBtn] = useState(props.displayGoHomeBtn || 'none');
    const [displayDiscoveryBtn, setDisplayDiscoveryBtn] = useState(props.displayDiscoveryBtn || 'none');
    const [isToggleOn, setIsToggleOn] = useState(false);
	const [isSignUpToggleOn, setIsSignUpToggleOn] = useState(false);
    const [isSignInToggleOn, setIsSignInToggleOn] = useState(false);
    const [actionCompleted, setActionCompleted] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    const [actionCompletedType, setActionCompletedType] = useState(null);

    const [profileMenuVisible, setProfileMenuVisible] = useState(false);
    const [isCreateToggleOn, setIsCreateToggleOn] = useState(false);
    const userId = userMetadata ? userMetadata.id : "";
    const navigate = useNavigate();

    const [isResetPwdToggleOn, setResetPwdToggleOn] = useState(false);

    const handleSignInCompleted = () => {
		setActionCompleted(true);
		navigate('/discovery');
	}

    const resetPwdClick = () => {
		setResetPwdToggleOn(!isResetPwdToggleOn);
		setActionCompleted(false);
	};

    const resetPwdCompleted = () => {
		setActionCompleted(true);
	}
    
    const handleClick = () => {
        setIsToggleOn(!isToggleOn);
    }

    const handleSignUpClick = () => {
        setIsSignUpToggleOn(!isSignUpToggleOn);
        setActionCompletedType(null);
        setActionCompleted(false);
    };

    const handleActionCompleted = (actionType) => {
        if (actionType) { setActionCompletedType(actionType); }
        setActionCompleted(true);
        setIsSignUpToggleOn(false);
        // This is for timing the prompt message, then auto closing it after 1000ms/1 sec
        // const id = setTimeout(() => {
        //     setIsSignUpToggleOn(false);
        // }, 1000);
        // setTimeoutId(id);
    };

    const handleBrowseClick = () => {
		if(isSignInToggleOn || isSignUpToggleOn) {
			setIsSignInToggleOn(false);
			setIsSignUpToggleOn(false);
		}
		setProfileMenuVisible(false);
		navigate(`/discovery`);
	}

    // const handleCreateClick = () => {
	// 	if (isSignInToggleOn) {
	// 		setIsSignInToggleOn(false);
	// 		setIsSignUpToggleOn(false);
	// 	}
	// 	if (isSignUpToggleOn) {
	// 		setIsSignInToggleOn(false);
	// 		setIsSignUpToggleOn(false);
	// 	}
	// 	setIsCreateToggleOn(!isCreateToggleOn);
	// 	setActionCompleted(false);
	// 	setProfileMenuVisible(false);
	// }

    const handleProfileClick = () => {
		if(isSignInToggleOn) {
			setIsSignInToggleOn(false);
			setIsSignUpToggleOn(false);
		}
		if(isSignUpToggleOn) {
			setIsSignInToggleOn(false);
			setIsSignUpToggleOn(false);
		}
		navigate('/profile/' + userId);
		setProfileMenuVisible(false);
	};

    const handleSignInClick = () => {
		setIsSignInToggleOn(!isSignInToggleOn);
		setActionCompleted(false);
	};

    const handleCreateCompleted = () => {
		setActionCompleted(true);
		const id = setTimeout(() => {
			setIsCreateToggleOn(false);
			window.location.reload();
		}, 1000);
		setTimeoutId(id);
		if (window.location.pathname.includes("/profile") ) { 
            navigate('/profile/' + userId);
		} else {
			navigate(window.location.pathname);
		}
	}

    useEffect(() => {
        setHeader(props.header);
    }, [props.header]);

    useEffect(() => {
        setSubHeader(props.subHeader);
    }, [props.subHeader]);

    // Get messaging info from the config files
    const messaging = getEnvConfig().messaging;

    return (
        <section id="home" className="video-hero" data-section="home">
            <CreateAccountModal isSignUpToggleOn={isSignUpToggleOn} handleClick={handleSignUpClick} handleSignInClick={handleSignInClick}/>
            {isSignInToggleOn && 
                <SignInModal resetPwdClick={resetPwdClick} isSignInToggleOn={isSignInToggleOn} handleClick={handleSignInClick} onActionCompleted={handleSignInCompleted} handleSignUpClick={handleSignUpClick} />
            }
			<ResetPasswordModal isResetPwdToggleOn={isResetPwdToggleOn} handleClick={resetPwdClick} onActionCompleted={resetPwdCompleted} />
            <div className="display-t text-center">
                <div className="display-tc display-tc2 page-header-container">
                    <div className={"page-header-wrapper"}>
                        <div>
                            <p style={{color: "white"}} className="page-subheader display-linebreak">{preHeader}</p>
                            <h1 className="page-header display-linebreak">{header}</h1>
                            { props.mainPhoto === undefined ? null : (
                            <div className="page-image-header">
                                <video className='hero' alt="sidejawn-header-photo" autoPlay loop muted playsInline>
                                    <source src={props.mainPhoto} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            )}
                            {subHeader && subHeader !== '' && (
                                <p style={{color: "white"}} className="page-subheader display-linebreak">{subHeader}</p>
                            )}
                            <div style={{display:'flex', gap:'20px', justifyContent:'center'}}>
                                {displayLearnMoreBtn != 'none' &&
                                    <Link to="/about">
                                        <Button className="page-header-btn btn-secondary" style={{color: "white", display: displayLearnMoreBtn}} onClick={handleClick}>
                                            About Us
                                        </Button>
                                    </Link>
                                }
                                {displayGoHomeBtn != 'none' && 
                                    <Link to="/">
                                        <Button className="page-header-btn btn-secondary" style={{color: "white", display: displayGoHomeBtn}} onClick={handleClick}>
                                            Go Home
                                        </Button>
                                    </Link>
                                }
                                <Link to="/product/history">
                                    <Button className="page-header-btn" variant="primary">
                                        See what used to be
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default PageHeader;
